<template>
    <div>
        <v-row align="baseline">
            <v-col>문서번호</v-col>
            <v-col><v-text-field v-model="value.documentNo" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>주문번호</v-col>
            <v-col><v-text-field v-model="value.orderNumber" hide-details dense/></v-col>
        </v-row>
        <v-divider />
        <v-row align="baseline">
            <v-col>거래금액(공급가액 + 세액)</v-col>
            <v-col><v-text-field v-model="value.cost" hide-details dense/></v-col>
        </v-row>
        <v-divider />
        <v-row align="baseline">
            <v-col>거래구분</v-col>
            <v-col><v-select v-model="value.tradeUsage" :items="tradeUsageTypes" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>{{ identityNumLabels[value.tradeUsage] }}</v-col>
            <v-col><v-text-field v-model="value.identityNum" hide-details dense/></v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            documentNo: { type: String, default: "" },
            orderNumber: { type: String, default: "" },
            cost: { type: String, default: "" },
            tradeUsage: { type: String, default: "" },
            identityNum: { type: String, default: "" },
        },
    },
    data() {
        return {
            tradeUsageTypes: ["소득공제용", "지출증빙용"],
            identityNumLabels: {
                ["소득공제용"]: "식별번호 (주민등록/휴대폰/카드번호 중 택 1)",
                ["지출증빙용"]: "식별번호 (사업자번호/주민등록/휴대폰/카드번호 중 택 1)",
            },
        };
    },
};
</script>

<style></style>
